import { render, staticRenderFns } from "./ProductCategoryCreate.vue?vue&type=template&id=afb892ea&scoped=true"
import script from "./ProductCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb892ea",
  null
  
)

export default component.exports